export default "__VITE_ASSET__c6d3ec8b__"